import { gql } from 'apollo-boost'

const UNASSIGN_MENU_SCRAPING_CLUSTER = gql`
  mutation unassignMenuScrapingCluster($id: ID!) {
    unassignMenuScrapingCluster(id: $id) {
      id
      modifiedDate
    }
  }
`

export default UNASSIGN_MENU_SCRAPING_CLUSTER
